<script setup lang="ts">
import type { DropdownsStateKeys } from '~/composables/states'

const scrollLock = useState('scrollLock')
const dropdownsOpenState = useDropdowns()

const handleClick = () => {
    // save current state
    const currentState = dropdownsOpenState.value.menu
    // close all opened dropdowns
    Object.keys(dropdownsOpenState.value).map(
        (key) => (dropdownsOpenState.value[key as DropdownsStateKeys] = false)
    )
    // toggle menu state
    dropdownsOpenState.value.menu = !currentState
    // toggle lock scrolling
    scrollLock.value = !currentState
}
</script>
<template>
  <button
    id="menu-toggle"
    :aria-label="$t('Zobraziť menu')"
    aria-haspopup="true"
    type="button"
    class="menu-toggle position-absolute overflow-hidden d-flex align-items-center d-md-none p-0 border-0 bg-transparent end-0 top-50 translate-middle-y me-5"
    :aria-expanded="dropdownsOpenState.menu"
    @click="handleClick"
  >
    <svg
      v-if="!dropdownsOpenState.menu"
      width="22"
      height="16"
      viewBox="0 0 22 16"
    >
      <path
        d="M21.667 1.93303H0.333008V0.733032H21.667V1.93303ZM21.667 8.60002H0.333008V7.40002H21.667V8.60002ZM21.667 15.267H0.333008V14.067H21.667V15.267Z"
        fill="black"
      />
    </svg>

    <svg
      v-else
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        d="M9.00006 10.0607L16.4697 17.5303L17.5304 16.4697L10.0607 9L17.5304 1.53033L16.4697 0.469666L9.00006 7.93934L1.53039 0.469666L0.469727 1.53033L7.9394 9L0.469727 16.4697L1.53039 17.5303L9.00006 10.0607Z"
        fill="black"
      />
    </svg>
  </button>
</template>
<style lang="scss">
@import './MenuToggle.scss';
</style>
